module.exports = __webpack_public_path__ + "img/rabbit of good fortune.e7a37473.png";